import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../actions/application";
import { APPLICATION_CONTEXTS } from "../../constants";
import ActionDescription from "./images/descriptions/ActionThriller_description.png";
import DramaDescription from "./images/descriptions/Drama_description.png";
import ClassicsDescription from "./images/descriptions/Classics_description.png";
import ComedyDescription from "./images/descriptions/Comedy_description.png";
import EspanolDescription from "./images/descriptions/EnEspanol_description.png";
import KidsDescription from "./images/descriptions/KidsFamily_description.png";

class Description extends Component {
  /**************
   * Properties *
   **************/
  state = {
    baseUrl: "/movies/categories",
    alphaListingUrl: "/movies/listing",
    videoDescriptions: [
      "action",
      // "classics",
      // "comedy",
      // "drama",
      // "espanol",
      "kids",
    ],
    descriptions: {
      action: ActionDescription,
      classics: ClassicsDescription,
      comedy: ComedyDescription,
      drama: DramaDescription,
      espanol: EspanolDescription,
      kids: KidsDescription,
    },
  };

  /*******************
   * Private methods *
   *******************/

  getCurrentMovieName = () => this.props.match.params.movieName;

  getCurrentCategoryName = () => this.props.match.params.categoryName;

  getCurrentCategoryImage = () =>
    this.state.pages[this.getCurrentCategory().page];

  goToMainMenu = () => this.props.history.push("/main_menu");

  getBackRoute() {
    let backRoute;
    if (this.props.match.params.backPath === "main_menu") {
      backRoute = `/${this.props.match.params.backPath}`;
    } else if (
      this.props.location.state &&
      this.props.location.state.backPath &&
      this.props.location.state.backPath !== ""
    ) {
      backRoute = this.props.location.state.backPath;
    } else {
      backRoute = `${this.state.baseUrl}/${this.getCurrentCategoryName()}`;
    }
    return backRoute;
  }

  goBack = () => this.props.history.push(this.getBackRoute());

  goToAlphaListing = () =>
    this.props.history.push(
      `/movies/listing/${this.getCurrentCategoryName()}/${this.getCurrentMovieName()}`
    );

  goToScreen = () =>
    this.props.history.push(
      `/movies/screen/${this.getCurrentCategoryName()}/${this.getCurrentMovieName()}`
    );

  goToScreenOrVideo = () =>{
    if (this.state.videoDescriptions.includes(this.getCurrentMovieName())) {
      this.goToVideo();
    } else {
      this.goToScreen();
  }};

  goToVideo = () =>
    this.props.history.push(
      `/movies/video/${this.getCurrentCategoryName()}/${this.getCurrentMovieName()}`,
      { backPath: this.getBackRoute() }
    );

  handleOnKeyUp = (event) => {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    switch (event.key) {
      case "Enter":
        this.goToScreenOrVideo();
        break;
      case "m":
      case "M":
        this.goToMainMenu();
        break;
      case "b":
      case "B":
        this.goBack();
        break;
      case "1":
        this.goToAlphaListing();
        break;
      default:
    }
  };

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for component that will mount.
   *
   * This method will add a listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillMount() {
    document.addEventListener("keyup", this.handleOnKeyUp, false);
  }

  /**
   * Performs various actions for component that will unmount.
   *
   * This method will remove the listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleOnKeyUp);
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div>
        <img
          className="description"
          src={this.state.descriptions[this.getCurrentMovieName()]}
          alt=""
        />
        <button className="main-menu" onMouseUp={this.goToMainMenu} />
        <button className="back" onMouseUp={this.goToCategory} />
        <button className="alpha-listing" onMouseUp={this.goToAlphaListing} />
        <button className="watch-movie" onMouseUp={this.goToScreenOrVideo} />
      </div>
    );
  }
}

const ConnectedDescription = connect(
  (state) => ({
    context: state.application.currentContext,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(Description);

export default withRouter(ConnectedDescription);
